import { Injectable, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly isBrowser: boolean;

  constructor() {
    const platformId = inject(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  success(message: string, title: string = 'Success') {
    if (this.isBrowser) {
      // Swal.fire({
      //   icon: 'success',
      //   title,
      //   text: message,
      // });
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
      Toast.fire({
        icon: "success",
        title: title,
        text: message,
      });
    }
  }

  error(message: string, title: string = 'Error') {
    if (this.isBrowser) {
      // Swal.fire({
      //   icon: 'error',
      //   title,
      //   text: message,
      // });
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
      Toast.fire({
        icon: "error",
        title: title,
        text: message,
      });
    }
  }

  warning(message: string, title: string = 'Warning') {
    if (this.isBrowser) {
      Swal.fire({
        icon: 'warning',
        title,
        text: message,
      });
    }
  }

  info(message: string, title: string = 'Info') {
    if (this.isBrowser) {
      Swal.fire({
        icon: 'info',
        title,
        text: message,
      });
    }
  }

  async confirm(
    message: string,
    title: string = 'Are you sure?',
    confirmText: string = 'Yes',
    cancelText: string = 'Cancel'
  ): Promise<boolean> {
    if (!this.isBrowser) return Promise.resolve(false);

    return Swal.fire({
      title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
    }).then(result => result.isConfirmed);
  }
}
